import { render, staticRenderFns } from "./select_lawyer.vue?vue&type=template&id=e954ba02&scoped=true&"
import script from "./select_lawyer.vue?vue&type=script&lang=js&"
export * from "./select_lawyer.vue?vue&type=script&lang=js&"
import style0 from "./select_lawyer.vue?vue&type=style&index=0&id=e954ba02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e954ba02",
  null
  
)

export default component.exports